module.exports = __webpack_public_path__ + "static/media/bgame-bg.caf40a4d.jpg";